import { IAction, ITypesState } from "types/redux"
import * as actions from 'actions/settingsActions'

const initialState = {
  items: [],
  isLoading: false,
  error: null
}

const postTypesReducer = (state: ITypesState = initialState, action: IAction): Object => {
  switch (action.type) {
    case actions.GET_POST_TYPES_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case actions.GET_POST_TYPES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        items: action.data
      }
    case actions.GET_POST_TYPES_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.error
      }
    case actions.POST_TYPE_TITLE_CHANGE:
      const { id, name } = action.data
      const newTypes = [...state.items]
      const index = newTypes.findIndex(el => el.id === id)
      newTypes[index].name = name

      return {
        ...state,
        items: newTypes
      }
    case actions.CREATE_POST_TYPE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case actions.CREATE_POST_TYPE_SUCCESS:
      const newData = [...state.items.filter(el => el.id !== 0)]

      return {
        ...state,
        isLoading: false,
        items: [...newData, action.data]
      }
    case actions.CREATE_POST_TYPE_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.error
      }
    case actions.UPDATE_POST_TYPE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case actions.UPDATE_POST_TYPE_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case actions.UPDATE_POST_TYPE_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.error
      }
    case actions.DELETE_POST_TYPE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case actions.DELETE_POST_TYPE_SUCCESS:
      const newPostTypes = state.items.filter(el => el.id !== action.data)
      return {
        ...state,
        isLoading: false,
        items: newPostTypes
      }
    case actions.DELETE_POST_TYPE_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.error
      }
    default:
      return state
  }
}

export default postTypesReducer